import React, { useState } from 'react';
import { WEB_APP_LINK } from '../../data/links';

const PricingSection = () => {
  const [faqSectionOpen, setFaqSectionOpen] = useState(false);

  const toggleFaqSection = () => {
    setFaqSectionOpen(!faqSectionOpen);
  };

  const faqData = [
    {
      question: "Can I try Ferritico for free?",
      answer: "Yes. Contact Ferritico for a live demo."
    },
    {
      question: "Is my data secure with Ferritico?",
      answer: "Yes. Customer data and results remain isolated and confidential, with private cloud or on-premises options available for industrial needs."
    }
  ];

  const plans = [
    // {
    //   name: "Starter Free Trial",
    //   subtitle: "Free Trial",
    //   description: "Full access to CCT predictions for 14 days.",
    //   price: "Free",
    //   cta: "Start Free Trial",
    //   popular: false
    // },
    {
      name: "Early Technology Adopter Subscription",
      subtitle: "Subscription",
      description: "Single user access to unlimited CCT and TTT predictions.",
      price: "Contact us",
      cta: "Contact for Pricing",
      popular: false
    },
    {
      name: "Industrial User Subscription",
      subtitle: "Subscription",
      description: "Full access to CCT and TTT predictions, tempering and hardenability. Customization of modules and API integrations for batch calculations.",
      price: "Contact us",
      cta: "Contact for Pricing",
      popular: true
    },
    {
      name: "Academic User Subscription",
      subtitle: "Academic",
      description: "Academic single user access to unlimited CCT and TTT predictions.",
      price: "Contact us",
      cta: "Contact for Pricing",
      popular: false
    }
  ];

  return (
    <section className="pricing-section" id="pricing">
      <div className="value-container">
        <div className="section-header">
          <span className="section-label">Pricing</span>
          <h2 className="section-title">Flexible Plans for Every Need</h2>
        </div>
        <div className="pricing-grid">
          {plans.map((plan, index) => (
            <div key={index} className={`pricing-card ${plan.popular ? 'popular' : ''}`}>
              {plan.popular && (
                <div className="popular-badge">Most Popular</div>
              )}
              <div className="pricing-header">
                <h3 className="plan-name">{plan.name}</h3>
                <p className="plan-subtitle">{plan.subtitle}</p>
                <div className="plan-price">
                  <span className="price">{plan.price}</span>
                </div>
              </div>
              <div className="pricing-content">
                <p className="plan-description">{plan.description}</p>
              </div>
              <div className="pricing-footer">
                {plan.name === "Starter Free Trial" ?
                  <a href={WEB_APP_LINK} className={`pricing-cta ${plan.popular ? 'primary' : 'secondary'}`}>
                    {plan.cta}
                  </a> :
                  <a href="#contact" className={`pricing-cta ${plan.popular ? 'primary' : 'secondary'}`}>
                    {plan.cta}
                  </a>
                }
              </div>
            </div>
          ))}
        </div>

        <div style={{ marginTop: '40px' }}>
          <div className="solutions-cta">
            <a href="#contact" className="btn-primary">
              Contact Ferritico for a pricing consultation.
            </a>
          </div>
        </div>

        <div className={`pricing-faq ${faqSectionOpen ? 'faq-section-open' : ''}`} id="faq">
          <button
            className="faq-section-toggle"
            onClick={toggleFaqSection}
            aria-expanded={faqSectionOpen}
          >
            <h3>FAQ</h3>
            <span className="faq-section-icon">{faqSectionOpen ? '−' : '+'}</span>
          </button>

          <div className="faq-content">
            <div className="faq-accordion">
              {faqData.map((faq, index) => (
                <div key={index} className="faq-item">
                  <h4>{faq.question}</h4>
                  <p>{faq.answer}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
